/* eslint-disable react-hooks/exhaustive-deps */
import { useAction } from "@corets/use-action"
import { useEffect, useState } from "react"
import { Route, useHistory } from "react-router-dom"
import { EditIcon, DeleteIcon } from "../../../assets/icons"
import { WPlus } from "../../../assets/images"
import { links } from "../../../config/links"
import { AlertDialog } from "../../oneportal/components/Dialogs/AlertDialog"
import { PageContentWithSearchBar } from "../../oneportal/components/PageContentWithSearchbar"
import { PagePagination } from "../../oneportal/components/PagePagination/PagePagination"
import { usePagePagination } from "../../oneportal/components/PagePagination/usePagePagination"
import { TBody } from "../../oneportal/components/Table/TBody"
import { TBodyCell } from "../../oneportal/components/Table/TBodyCell"
import { TBodyRow } from "../../oneportal/components/Table/TBodyRow"
import { TBodySkeleton } from "../../oneportal/components/Table/TBodySkeleton"
import { THead } from "../../oneportal/components/Table/THead"
import { THeadCell } from "../../oneportal/components/Table/THeadCell"
import { THeadRow } from "../../oneportal/components/Table/THeadRow"
import { TPlaceholder } from "../../oneportal/components/Table/TPlaceholder"
import { TWrapper } from "../../oneportal/components/Table/TWrapper"
import { useTableSorter } from "../../oneportal/components/Table/useTableSorter"
import { useAlert } from "../../oneportal/hooks/useAlert"
import { useApiClient } from "../../oneportal/hooks/useApiClient"
import { useQuery } from "../../oneportal/hooks/useQuery"
import "../../../assets/style/danhmuc.css"

import { dateVNFormat } from "../../oneportal/helpers/utils"
import { deleteReflection, getAllReflection, reflectionParams } from "../services/api/reflectionProcessing"

import { CreateOrUpdateReflectionProcessingDialog } from "../components/ReflectionProcessing/CreateOrUpdateReflectionProcessingDialog/CreateOrUpdateReflectionProcessingDialog"
import { SearchReflectionProcessingFormType } from "../components/ReflectionProcessing/SearchReflectionProcessingForm/createSearchReflectionProcessingForm"
import { SearchReflectionProcessingForm } from "../components/ReflectionProcessing/SearchReflectionProcessingForm/SearchReflectionProcessingForm"

const ListReflectionProcessingUnit = () => {
  const api = useApiClient()
  const history = useHistory()
  const sorter = useTableSorter()
  const alert = useAlert()

  const reflectionAction = useAction(async () => await getAllReflection(api, reflectionParams))
  const [reflectionId, setReflectionId] = useState<number | undefined>(undefined)

  const pagination = usePagePagination({
    pageCount: reflectionAction.getResult()?.content.pageCount,
  })
  const [query, , pathQuery] = useQuery<reflectionParams>({})

  const reflectionParams: reflectionParams = {
    sortExpression: sorter.query.sort && `${sorter.query.sort} ${sorter.query.direction}`,
    pageIndex: pagination.query.pageIndex,
    pageSize: pagination.query.pageSize,
    name: query.keyword,
    phoneNumber: query.phoneNumber,
    address: query.address,
  }

  useEffect(() => {
    reflectionAction.run()
  }, [JSON.stringify(reflectionParams)])

  const handleSearchReflection = (data: SearchReflectionProcessingFormType) =>
    pathQuery({ ...data, pageSize: undefined, pageIndex: undefined })

  const handleDeleteReflectionField = async () => {
    const res = await deleteReflection(api, reflectionId as number)
    setReflectionId(undefined)
    if (res?.content.status) {
      alert("Thành công", { variant: "success" })
      reflectionAction.run()
    } else {
      alert("Thất bại", { variant: "error" })
    }
  }

  return (
    <PageContentWithSearchBar
      pageTitle="Danh sách đơn vị xử lý"
      sectionClassName="qlds-page"
      searchbarClassName="list-user-form"
      searchBar={
        (!!reflectionAction.getResult()?.content.items.length || !!Object.keys(query).length) && (
          <SearchReflectionProcessingForm onSubmit={handleSearchReflection} defaultValue={query} />
        )
      }
    >
      <>
        <TWrapper tableClassName="table__user" tableContainerClassName="wrap-table__cate">
          {reflectionAction.isRunning() && <TBodySkeleton count={10} colSpan={8} />}
          {!!reflectionAction.getResult()?.content.items.length && (
            <>
              <THead>
                <THeadRow>
                  <THeadCell>STT</THeadCell>
                  <THeadCell {...sorter.bind("name")}>Tên</THeadCell>
                  <THeadCell {...sorter.bind("adddress")}>Địa chỉ</THeadCell>
                  <THeadCell {...sorter.bind("phoneNumber")}>Số điện thoại</THeadCell>
                  <THeadCell {...sorter.bind("modifiedDate")}>Ngày sửa</THeadCell>
                  <THeadCell {...sorter.bind("modifiedBy")}>Người sửa</THeadCell>
                  <THeadCell>Hành động</THeadCell>
                </THeadRow>
              </THead>
              <TBody>
                {!reflectionAction.isRunning() &&
                  reflectionAction.getResult()?.content.items.map((item, index) => (
                    <TBodyRow key={item.id}>
                      <TBodyCell>
                        {(pagination.query.pageSize || 10) *
                          (pagination.query.pageIndex ? pagination.query.pageIndex - 1 : 0) +
                          index +
                          1}
                      </TBodyCell>
                      <TBodyCell>{item.name}</TBodyCell>
                      <TBodyCell>{item.address}</TBodyCell>
                      <TBodyCell>{item.phoneNumber}</TBodyCell>
                      <TBodyCell>{dateVNFormat(item.modifiedDate)}</TBodyCell>
                      <TBodyCell>{item.modifiedBy}</TBodyCell>
                      <TBodyCell>
                        <div className="action__user table-action d-flex align-items-center">
                          <button
                            type="button"
                            className="border-0 mr-3"
                            onClick={() =>
                              history.push(links.category.updateReflectionProcessingUnit(item.id.toString()))
                            }
                          >
                            <EditIcon />
                          </button>
                          <button type="button" className="border-0" onClick={() => setReflectionId(item.id)}>
                            <DeleteIcon className="icon" />
                          </button>
                        </div>
                      </TBodyCell>
                    </TBodyRow>
                  ))}
              </TBody>
            </>
          )}
        </TWrapper>
        {!reflectionAction.isRunning() &&
          !reflectionAction.getResult()?.content.items.length &&
          !Object.keys(query).length && (
            <TPlaceholder title="Không có dữ liệu">
              <button
                className="btn  btn-ct  btn-add btn-danger-ct  d-flex align-items-center"
                type="button"
                onClick={() => history.push(links.category.createReflectionProcessingUnit())}
              >
                Thêm đơn vị xử lý
                <img src={WPlus} alt="" />
              </button>
            </TPlaceholder>
          )}
        {!reflectionAction.isRunning() &&
          !reflectionAction.getResult()?.content.items.length &&
          !!Object.keys(query).length && <TPlaceholder title="Không có dữ liệu trùng khớp" />}
        {!!reflectionAction.getResult()?.content.items.length && (
          <PagePagination
            pageSize={pagination.query.pageSize}
            pageCount={reflectionAction.getResult()?.content.pageCount}
            {...pagination.bind()}
            pageIndex={pagination.query.pageIndex}
          />
        )}
      </>
      <Route path={links.category.createReflectionProcessingUnit()} exact>
        <CreateOrUpdateReflectionProcessingDialog onSuccess={() => reflectionAction.run()} />
      </Route>
      <Route path={links.category.updateReflectionProcessingUnit()} exact>
        <CreateOrUpdateReflectionProcessingDialog onSuccess={() => reflectionAction.run()} />
      </Route>

      <AlertDialog
        title="Xóa đơn vị xử lý"
        textContent="Bạn có muốn xoá dòng dữ liệu này?"
        open={!!reflectionId}
        onClose={() => setReflectionId(undefined)}
        onAgree={handleDeleteReflectionField}
      />
    </PageContentWithSearchBar>
  )
}

export default ListReflectionProcessingUnit
